import { state } from './state.js';

export const blocks = {
  render() {
    const { blocks: data, root } = state;
    if (!data.length) return;

    const block1 = root.querySelector('#acpb-block-1');
    const block2 = root.querySelector('#acpb-block-2');

    if (block1 && data[0]) {
      block1.innerHTML = `
        <div class="acpb-block">
          <h3>${data[0].title || ''}</h3>
          <div class="acpb-block-images">
            ${data[0].images.map(img => `
              <picture>
                ${img.image_avif ? `<source srcset="${prestashop.urls.base_url}img/acpb/${img.image_avif}" type="image/avif">` : ''}
                ${img.image_webp ? `<source srcset="${prestashop.urls.base_url}img/acpb/${img.image_webp}" type="image/webp">` : ''}
                <img src="${prestashop.urls.base_url}img/acpb/${img.image}" class="acpb-block-image">
              </picture>
            `).join('')}
          </div>
        </div>`;
    }

    if (block2 && data[1]) {
      block2.innerHTML = `
        <div class="acpb-block">
          <span><i class="icon-lock"></i>${data[1].title || ''}</span>
          <div class="acpb-block-images">
            ${data[1].images.map(img => `
              <picture>
                ${img.image_avif ? `<source srcset="${prestashop.urls.base_url}img/acpb/${img.image_avif}" type="image/avif">` : ''}
                ${img.image_webp ? `<source srcset="${prestashop.urls.base_url}img/acpb/${img.image_webp}" type="image/webp">` : ''}
                <img src="${prestashop.urls.base_url}img/acpb/${img.image}" class="acpb-block-image">
              </picture>
            `).join('')}
          </div>
        </div>`;
    }
  }
};
